<template>
  <div>
    <router-link class="rule" to="/rule">
      <img src="~@this/assets/rule.png" alt="" />
    </router-link>
    <IndexTop :taskList="taskList" @clickCompleteTask="clickCompleteTask"></IndexTop>
    <Border>
      <img slot="title" class="content-title" src="~@this/assets/title1.png" alt="" />
      <CarPirce
        slot="content"
        :askedPriceIds="askedPriceIds"
        :carPrizeList="carPrizeList"
        @select="selectCarPrize"
      ></CarPirce>
      <div
        slot="bottom"
        class="car-other"
        @click="
          () => {
            this.needSeries = true;
            changeShowMoreBrand();
          }
        "
      >
        查看其它车型成交价&gt;
      </div>
    </Border>
    <!-- <Border>
      <img slot="title" class="content-title" src="~@this/assets/title2.png" alt="" />
      <CouponS slot="content" :couponList="mainCouponList" @clickCoupon="clickCoupon">
        <div class="city" @click="changeShowCityList()">{{ city.name || '定位中...' }}</div>
      </CouponS>
    </Border> -->
    <Border>
      <img slot="title" class="content-title" src="~@this/assets/title3.png" alt="" />
      <CouponN
        slot="content"
        :couponList="normalCouponList"
        :couponMetal="normalCouponMetal"
        @clickCoupon="clickCoupon"
      >
        <HotBrand
          :brand="brandSelected"
          :hotBrandList="hotBrandList"
          :isMore="isMore"
          @selectItem="clickBrand"
          @clickMore="
            () => {
              this.needSeries = false;
              changeShowMoreBrand();
            }
          "
        ></HotBrand>
      </CouponN>
      <div
        slot="bottom"
        v-show="normalCouponList.length < normalCouponMetal.total"
        @click="getNormalCouponList"
        class="more-coupon"
      >
        展开更多优惠券&gt;&gt;
      </div>
    </Border>
    <Border>
      <img slot="title" class="content-title" src="~@this/assets/title6.png" alt="" />
      <pre slot="content" class="pre">
        1、参与做任务攒钱互动，完成任务可抽随机现金红包奖励；
        2、领取优惠并完成购车用户，凭发票可获得4888元返现大奖机会； Tips:参与购车优惠用户需提交上传领奖资料信息，信息提交审核通过后等待后台抽取中奖名单，届时中奖用户将会收到工作人员电话（020-38895471）与您联系返现领取事宜，数量有限，先到先得；
        （资料填写地址：<a href="https://u1.pangku.com/872648b3">https://u1.pangku.com/872648b3</a>）
      </pre>
      <div slot="bottom" @click="gotoRule" class="more-coupon">查看详细活动规则&gt;&gt;</div>
    </Border>
    <IndexBar
      :hot="false"
      :showLogo="false"
      :showDataPopup="showCityList"
      :dataList="cityList"
      @selectItem="clickCity"
      @close="changeShowCityList"
      data-key="name"
      data-name="cities"
    >
    </IndexBar>
    <IndexBar
      :hot="true"
      :showDataPopup="showMoreBrand"
      :dataList="brandList"
      @selectItem="
        (item) => {
          if (this.needSeries) {
            clickBrandGetAskPriceList(item);
          } else {
            clickBrand(item);
          }
        }
      "
      @close="changeShowMoreBrand"
    >
    </IndexBar>
    <IndexBar
      :hot="false"
      :anchorShow="false"
      :showDataPopup="showMoreSeries"
      :dataList="moreAskPriceList"
      @selectItem="selectMorePrice"
      @close="changeShowMoreSeries"
    ></IndexBar>
    <Receive
      :showSeries="showSeriesDialog"
      :showReceive="showReceiveDialog"
      :agreementCheckbox.sync="agreementCheckbox"
      :seriesList="seriesList"
      :series="seriesSelected"
      :showAgreement="showAgreement"
      @selectSeries="selectSeries"
      @clickReceive="clickReceive"
      @gotoAgreement="gotoAgreement"
      @changeShowReceiveDialog="changeShowReceiveDialog"
      @changeShowSeriesDialog="changeShowSeriesDialog"
    ></Receive>
    <AskPrice
      :showAskPriceDialog="showAskPriceDialog"
      :showSuccessDialog="showSuccessDialog"
      :userInfo="userInfo"
      :serialInfo="askPriceInfo"
      @clickAskPrice="clickAskPrice"
      @changeShowAskPriceDialog="changeShowAskPriceDialog"
      @changeShowSuccessDialog="changeShowSuccessDialog"
    ></AskPrice>
  </div>
</template>
<script>
import Border from '@this/components/Border.vue';
import CouponN from '@this/components/CouponN.vue';
import CouponS from '@this/components/CouponS.vue';
import HotBrand from '@this/components/HotBrand.vue';
import IndexBar from '@this/components/IndexBar.vue';
import CarPirce from '@this/components/CarPirce.vue';
import Receive from '@this/components/ReceiveCoupon.vue';
import AskPrice from '@this/components/AskPrice.vue';
import IndexTop from '@this/components/IndexTop.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      needSeries: false,
    };
  },
  watch: {
    brandSelected() {
      this.getNormalCouponList({ page: 1 });
    },
    city() {
      this.getNormalCouponList({ page: 1 });
      this.getMainCouponList();
    },
    uid: {
      handler() {
        this.getNormalCouponList({ page: 1 });
        this.getMainCouponList();
        this.getCarPrizeList();
      },
      immediate: true,
    },
  },
  created() {
    this.initBrand();
    this.getTaskList();
    this.getAskedPriceIds();
  },
  computed: {
    ...mapState('city', ['city', 'cityList', 'showCityList']),
    ...mapState('user', ['uid', 'userInfo']),
    ...mapState('brand', ['hotBrandList', 'brandSelected', 'showMoreBrand', 'brandList', 'showMoreSeries']),
    ...mapGetters('brand', ['isMore']),
    ...mapState('coupon', [
      'seriesList',
      'mainCouponList',
      'normalCouponList',
      'normalCouponMetal',
      'showSeriesDialog',
      'showReceiveDialog',
      'seriesSelected',
      'showAgreement',
    ]),
    ...mapState('clue', ['carPrizeList', 'askPriceInfo', 'showAskPriceDialog', 'showSuccessDialog', 'askedPriceIds']),
    ...mapState('task', ['taskList']),
    agreementCheckbox: {
      get() {
        return this.$store.state.coupon.agreementCheckbox;
      },
      set(val) {
        this.$store.commit('coupon/setAgreementCheckbox', val);
      },
    },
    moreAskPriceList: {
      get() {
        return this.$store.state.brand.seriesList;
      },
      set(val) {
        this.$store.commit('brand/setSeriesList', val);
      },
    },
  },
  methods: {
    ...mapActions('city', ['clickCity', 'changeShowCityList']),
    ...mapActions('brand', ['getBrandList', 'clickBrand', 'initBrand', 'changeShowMoreBrand', 'changeShowMoreSeries']),
    ...mapActions('coupon', [
      'getNormalCouponList',
      'clickCoupon',
      'getMainCouponList',
      'selectSeries',
      'gotoAgreement',
      'changeShowSeriesDialog',
      'changeShowReceiveDialog',
      'clickReceive',
    ]),
    ...mapActions('clue', [
      'getCarPrizeList',
      'clickAskPrice',
      'getAskPriceInfo',
      'changeShowAskPriceDialog',
      'changeShowSuccessDialog',
      'clickBrandGetAskPriceList',
      'selectCarPrize',
      'selectMorePrice',
      'getAskedPriceIds',
    ]),
    ...mapActions('task', ['clickCompleteTask', 'getTaskList']),
    gotoRule() {
      this.$router.push('/rule');
    },
  },
  components: {
    Border,
    HotBrand,
    CouponN,
    IndexBar,
    CouponS,
    CarPirce,
    Receive,
    AskPrice,
    IndexTop,
  },
};
</script>

<style scoped lang="scss">
.rule {
  position: absolute;
  z-index: 1;
  right: 0;
  top: 20px;
  img {
    width: 48px;
  }
}
.city {
  position: absolute;
  right: 35px;
  height: 40px;
  line-height: 40px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 0 40px 0 20px;
  color: #1b5af1;
  top: -40px;
  background: #fffde0;
  &::after {
    content: '';
    position: absolute;
    right: 10px;
    top: 15px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: #1b5af1;
  }
}
.car-other {
  text-align: center;
  margin: 0 auto;
}
.more-coupon,
.car-other {
  text-align: center;
  min-width: 285px;
  padding: 0 10px;
  height: 50px;
  line-height: 50px;
  border-radius: 25px;
  background: #156bf3;
  color: #75c9ff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%) scaleY(-1);
  top: 50px;
  z-index: 10;
}
.pre {
  font-size: 24px;
  line-height: 1.45;
  padding: 0 48px 10px 52px;
  color: #ffffff;
  white-space: pre-line;
  margin: 0 auto;
  a {
    color: #ffffff;
  }
}
</style>
